var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2766 9.62344L12.575 3.82969V3.82812C12.4563 3.47031 12.1735 3.25781 11.8203 3.25781C11.4547 3.25781 11.1563 3.46875 11.0438 3.80781L9.92815 7.13594H6.0719L4.95628 3.80781C4.84378 3.46875 4.54534 3.25781 4.17971 3.25781C3.81878 3.25781 3.51565 3.48906 3.42346 3.82969L1.72346 9.62344C1.65471 9.85313 1.74221 10.1141 1.9344 10.2594L7.69221 14.5781C7.73284 14.6344 7.78909 14.6766 7.85471 14.7L7.98909 14.8L8.1219 14.7C8.19846 14.6734 8.26253 14.6266 8.30784 14.5609L14.0641 10.2578C14.2578 10.1141 14.3453 9.85313 14.2766 9.62344ZM11.7422 4.01719C11.7578 3.98906 11.7875 3.9875 11.7969 3.9875C11.8141 3.9875 11.836 3.99219 11.85 4.03437L12.7782 7.15625H10.6922L11.7422 4.01719ZM4.12659 4.03281C4.14065 3.99219 4.16253 3.9875 4.17971 3.9875C4.2219 3.9875 4.22503 3.98906 4.23284 4.01406L5.2844 7.15781H3.22346L4.12659 4.03281ZM2.47815 9.725L2.91878 8.20469L6.08128 12.4266L2.47815 9.725ZM3.63284 7.90625H5.54065L6.9594 12.3484L3.63284 7.90625ZM8.01096 13.1203L6.33596 7.90625H9.6844L8.01096 13.1203ZM10.4782 7.90625H12.3453L9.0594 12.2937L10.4782 7.90625ZM9.84221 12.4984L13.0813 8.175L13.5422 9.725L9.84221 12.4984Z",
    fill: "#1F82FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.1761dc8bbfdba308c254492a9a8a3ac0.svg";
export { ForwardRef as ReactComponent };